import { defineCountry } from '../../../src/domain/country/factory';
import * as languages from '../../languages';

export default defineCountry({
  countryName: 'Bangladesh',
  countryCode: 'BD',
  countryHeaderCode: 'bd',
  mobileRegex: /^1[3456789]\d{8}$/,
  mobileLength: 10,
  mobileCode: '+880',
  defaultLanguage: languages.bn,
  googleAutoCompletePlacesCode: 'bd',
  consentForCallback: {
    shouldShow: true,
  },
  languages: {
    [languages.en.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: false,
        isMobileBkfEnabled: false,
      },
      defaultAgreedDocs: {
        tncUrl: '/en/terms-of-service',
        privacyPolicyUrl: '/en/privacy-policy',
      },
      currencyConfig: {
        currencyLocale: 'en-BD',
        currencyCode: 'BDT',
        maxMinorDigits: 2,
        currencySymbol: '৳',
      },
    },
    [languages.bn.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: false,
        isMobileBkfEnabled: false,
      },
      defaultAgreedDocs: {
        tncUrl: '/bn-BD/terms-of-service',
        privacyPolicyUrl: '/bn-BD/privacy-policy',
      },
      currencyConfig: {
        currencyLocale: 'en-BD',
        currencyCode: 'BDT',
        maxMinorDigits: 2,
        currencySymbol: '৳',
      },
    },
  },
  trackOrderContactSupportNumber: '+8809642410410',
});
